import { isValidEmail } from '../is-valid/index'

export interface ExtractEmailResult {
  domainName: string
  companyName: string
  contactName: string
}

/**
 * Extracts domain, company, and contact name from a valid email.
 * Returns undefined for invalid or unparseable emails.
 *
 * @example
 * extractEmail('john.doe@example.com') // { domainName: 'example.com', companyName: 'example', contactName: 'john.doe' }
 * extractEmail('invalid-email') // undefined
 */
export function extractEmail(email?: string | null): ExtractEmailResult | undefined {
  if (typeof email !== 'string' || !email.trim()) return undefined

  const normalizedEmail = email.trim()
  if (!isValidEmail(normalizedEmail)) return undefined

  const atIndex = normalizedEmail.lastIndexOf('@')
  const domainName = normalizedEmail.slice(atIndex + 1)

  return {
    domainName,
    companyName: domainName.split('.')[0],
    contactName: normalizedEmail.slice(0, atIndex),
  }
}
